import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PayrollFrequencyService {
    uri = `${environment.apiLocation}/PayrollFrequency`;
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    get(): Observable<Array<{ Payrollfrequency: number }>> {
        return this.http
            .get<Array<{ Payrollfrequency: number }>>(this.uri)
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'PayrollFrequencyService:reponse',
                        res
                    })
                )
            );
    }
}
